import React from "react";

const About: React.FC = () => {
    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#f8fafc",
                color: "#0f172a",
            }}
        >
            <style>
                {`
                    .about-page {
                        max-width: 1120px;
                        margin: 0 auto;
                        padding: 70px 20px 90px;
                    }

                    .about-hero {
                        max-width: 820px;
                        margin-bottom: 60px;
                    }

                    .about-eyebrow {
                        display: inline-block;
                        margin-bottom: 16px;
                        padding: 7px 13px;
                        border-radius: 999px;
                        background: #eef2ff;
                        color: #4338ca;
                        font-size: 12px;
                        font-weight: 800;
                        letter-spacing: .05em;
                        text-transform: uppercase;
                    }

                    .about-hero h1 {
                        margin: 0 0 20px;
                        font-size: clamp(38px, 5vw, 58px);
                        line-height: 1.08;
                        letter-spacing: -.04em;
                    }

                    .about-hero p {
                        margin: 0;
                        color: #64748b;
                        font-size: 19px;
                        line-height: 1.7;
                    }

                    .about-section {
                        margin-top: 65px;
                    }

                    .about-section h2 {
                        margin: 0 0 12px;
                        font-size: 32px;
                        letter-spacing: -.025em;
                    }

                    .about-section > p {
                        max-width: 760px;
                        margin: 0 0 28px;
                        color: #64748b;
                        font-size: 16px;
                        line-height: 1.7;
                    }

                    .about-grid {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        gap: 18px;
                    }

                    .about-card {
                        padding: 25px;
                        border: 1px solid #e2e8f0;
                        border-radius: 16px;
                        background: #fff;
                        box-shadow: 0 8px 25px rgba(15, 23, 42, .04);
                    }

                    .about-card-icon {
                        width: 44px;
                        height: 44px;
                        display: grid;
                        place-items: center;
                        margin-bottom: 18px;
                        border-radius: 11px;
                        background: #eef2ff;
                        color: #4338ca;
                        font-size: 11px;
                        font-weight: 900;
                    }

                    .about-card h3 {
                        margin: 0 0 10px;
                        font-size: 19px;
                    }

                    .about-card p {
                        margin: 0;
                        color: #64748b;
                        line-height: 1.65;
                    }

                    .about-highlight {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 22px;
                    }

                    .about-highlight-card {
                        padding: 30px;
                        border: 1px solid #c7d2fe;
                        border-radius: 18px;
                        background: linear-gradient(145deg, #fff, #eef2ff);
                    }

                    .about-highlight-card h3 {
                        margin: 0 0 12px;
                        font-size: 24px;
                    }

                    .about-highlight-card p {
                        margin: 0;
                        color: #64748b;
                        line-height: 1.7;
                    }

                    .about-flow {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 15px;
                    }

                    .about-step {
                        padding: 22px;
                        border: 1px solid #e2e8f0;
                        border-radius: 14px;
                        background: #fff;
                    }

                    .about-step-number {
                        width: 34px;
                        height: 34px;
                        display: grid;
                        place-items: center;
                        margin-bottom: 14px;
                        border-radius: 50%;
                        background: #4f46e5;
                        color: #fff;
                        font-size: 13px;
                        font-weight: 900;
                    }

                    .about-step h3 {
                        margin: 0 0 8px;
                        font-size: 17px;
                    }

                    .about-step p {
                        margin: 0;
                        color: #64748b;
                        font-size: 14px;
                        line-height: 1.6;
                    }

                    .about-faq {
                        display: grid;
                        gap: 12px;
                    }

                    .about-faq-item {
                        padding: 20px 22px;
                        border: 1px solid #e2e8f0;
                        border-radius: 13px;
                        background: #fff;
                    }

                    .about-faq-item h3 {
                        margin: 0 0 8px;
                        font-size: 16px;
                    }

                    .about-faq-item p {
                        margin: 0;
                        color: #64748b;
                        line-height: 1.6;
                    }

                    .about-bottom {
                        margin-top: 70px;
                        padding: 38px;
                        border-radius: 20px;
                        background: linear-gradient(
                            135deg,
                            #312e81,
                            #4f46e5,
                            #0ea5e9
                        );
                        color: #fff;
                    }

                    .about-bottom h2 {
                        margin: 0 0 10px;
                        font-size: 32px;
                    }

                    .about-bottom p {
                        max-width: 700px;
                        margin: 0;
                        color: #e0e7ff;
                        line-height: 1.7;
                    }

                    @media (max-width: 850px) {
                        .about-grid,
                        .about-flow {
                            grid-template-columns: repeat(2, 1fr);
                        }

                        .about-highlight {
                            grid-template-columns: 1fr;
                        }
                    }

                    @media (max-width: 600px) {
                        .about-page {
                            padding-top: 45px;
                        }

                        .about-grid,
                        .about-flow {
                            grid-template-columns: 1fr;
                        }

                        .about-bottom {
                            padding: 28px 22px;
                        }
                    }
                `}
            </style>

            <main className="about-page">

                <section className="about-hero">
                    <span className="about-eyebrow">
                        About TripSplitter
                    </span>

                    <h1>
                        Group expenses without the group spreadsheet.
                    </h1>

                    <p>
                        TripSplitter is built for friends, families, and groups
                        who want an easier way to track shared expenses and
                        settle up after a trip.
                    </p>
                </section>

                <section className="about-section">
                    <h2>
                        What TripSplitter does
                    </h2>

                    <p>
                        Instead of keeping a spreadsheet and manually working
                        out everyone's share, enter expenses as they happen.
                        TripSplitter keeps track of the people involved, what
                        was paid, and what each person ultimately owes.
                    </p>

                    <div className="about-grid">

                        <article className="about-card">
                            <div className="about-card-icon">
                                TRIP
                            </div>

                            <h3>
                                Organize trips
                            </h3>

                            <p>
                                Keep each group's participants, dates, expenses,
                                balances, and settlement information together.
                            </p>
                        </article>

                        <article className="about-card">
                            <div className="about-card-icon">
                                SPLIT
                            </div>

                            <h3>
                                Split expenses
                            </h3>

                            <p>
                                Choose who participated in each expense instead
                                of automatically splitting every purchase
                                between the whole group.
                            </p>
                        </article>

                        <article className="about-card">
                            <div className="about-card-icon">
                                MATH
                            </div>

                            <h3>
                                Calculate balances
                            </h3>

                            <p>
                                See the resulting balances and the payments
                                needed to settle the group.
                            </p>
                        </article>

                    </div>
                </section>

                <section className="about-section">

                    <h2>
                        Built for international travel
                    </h2>

                    <p>
                        A group trip does not always happen in one currency.
                        TripSplitter lets an expense keep the currency in
                        which it was actually paid while using the trip's
                        base currency for totals and settlement calculations.
                    </p>

                    <div className="about-highlight">

                        <article className="about-highlight-card">
                            <h3>
                                Pay in the currency you used
                            </h3>

                            <p>
                                Enter US$45 for dinner in Seattle, CAD$120 for
                                the hotel in Vancouver, or EUR€60 for a meal
                                in Europe. You don't have to manually convert
                                every purchase before entering it.
                            </p>
                        </article>

                        <article className="about-highlight-card">
                            <h3>
                                Keep one clear trip total
                            </h3>

                            <p>
                                Each expense retains its original currency and
                                conversion information, while the trip can use
                                a selected base currency for consistent
                                settlement calculations.
                            </p>
                        </article>

                    </div>
                </section>

                <section className="about-section">

                    <h2>
                        Save the expenses you enter again and again
                    </h2>

                    <p>
                        Many trips contain the same kinds of expenses. Save
                        frequently used items once and reuse them when adding
                        future purchases.
                    </p>

                    <div className="about-grid">

                        <article className="about-card">
                            <div className="about-card-icon">
                                HOTEL
                            </div>

                            <h3>
                                Save common expenses
                            </h3>

                            <p>
                                Create saved items for Hotel, Gas, Dinner,
                                Groceries, Ferry, Parking, or anything else
                                you regularly enter.
                            </p>
                        </article>

                        <article className="about-card">
                            <div className="about-card-icon">
                                FX
                            </div>

                            <h3>
                                Remember the currency
                            </h3>

                            <p>
                                Saved items can have their own currency, making
                                it easier to reuse expenses when you travel
                                between countries.
                            </p>
                        </article>

                        <article className="about-card">
                            <div className="about-card-icon">
                                AMT
                            </div>

                            <h3>
                                Optional default amount
                            </h3>

                            <p>
                                Save a typical amount when it makes sense, then
                                adjust it when the actual purchase is different.
                            </p>
                        </article>

                    </div>
                </section>

                <section className="about-section">

                    <h2>
                        How a trip comes together
                    </h2>

                    <div className="about-flow">

                        <article className="about-step">
                            <div className="about-step-number">1</div>

                            <h3>Create</h3>

                            <p>
                                Create a trip and choose its base currency.
                            </p>
                        </article>

                        <article className="about-step">
                            <div className="about-step-number">2</div>

                            <h3>Invite</h3>

                            <p>
                                Add the people who are sharing the expenses.
                            </p>
                        </article>

                        <article className="about-step">
                            <div className="about-step-number">3</div>

                            <h3>Track</h3>

                            <p>
                                Add purchases as they happen, using saved
                                items when convenient.
                            </p>
                        </article>

                        <article className="about-step">
                            <div className="about-step-number">4</div>

                            <h3>Settle</h3>

                            <p>
                                Review the balances and complete the payments
                                needed to settle the trip.
                            </p>
                        </article>

                    </div>
                </section>

                <section className="about-section">

                    <h2>
                        Frequently asked questions
                    </h2>

                    <div className="about-faq">

                        <article className="about-faq-item">
                            <h3>
                                Can I use different currencies in one trip?
                            </h3>

                            <p>
                                Yes. Expenses can be entered in different
                                supported currencies while the trip maintains
                                a base currency for calculations.
                            </p>
                        </article>

                        <article className="about-faq-item">
                            <h3>
                                Do saved items belong to a specific trip?
                            </h3>

                            <p>
                                Saved items are designed to be reused, so common
                                expenses don't need to be recreated from scratch
                                every time you start another trip.
                            </p>
                        </article>

                        <article className="about-faq-item">
                            <h3>
                                Can I change the amount of a saved item?
                            </h3>

                            <p>
                                Yes. A saved item provides convenient defaults;
                                the actual expense can be changed when you use it.
                            </p>
                        </article>

                        <article className="about-faq-item">
                            <h3>
                                Does every expense have to be shared equally?
                            </h3>

                            <p>
                                No. You can select the participants who shared
                                an expense, allowing different purchases to
                                involve different members of the group.
                            </p>
                        </article>

                    </div>
                </section>

                <section className="about-bottom">

                    <h2>
                        Less time calculating. More time travelling.
                    </h2>

                    <p>
                        TripSplitter is designed to make the financial side of
                        group travel easier to manage, from the first expense
                        to the final settlement.
                    </p>

                </section>

            </main>
        </div>
    );
};

export default About;